import { useMutation } from '@apollo/client'
import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Box, Flex, Text } from 'rebass/styled-components'
import { CUSTOMER_CREATE } from '../../graphql/mutations'
import { Toast } from '../../utils'
import Header from '../../components/Header'
import IonContent from '../../components/IonContent'
import { IonPage, IonLoading, IonItem, IonLabel, IonToast, IonButton, IonInput } from '@ionic/react'

export default () => {
    const [error, setError] = useState('')
    const [obj, setObj] = useState({
        email: '',
        pwd: '',
        confirmPwd: '',
    })
    const history = useHistory()
    const [mutate, { data = {}, loading, error: mutationError }] = useMutation(CUSTOMER_CREATE, {
        onCompleted({ customerCreate }) {
            const { userErrors, customer } = customerCreate
            if (customer) {
                setError('success')
                history.push('/login')
            } else {
                Toast(userErrors[0]?.message)
            }
        },
    })
    const handleRegister = () => {
        if (obj.confirmPwd !== obj.pwd) {
            Toast('password not equal')
            return
        }
        mutate({
            variables: {
                input: {
                    email: obj.email,
                    password: obj.pwd,
                },
            },
        })
    }

    const handleChange = type => e => {
        setObj({
            ...obj,
            [type]: e.detail.value,
        })
    }
    const { customerCreate } = data

    return (
        <IonPage pt="50px" px="30px">
            <Header title="register"></Header>
            <IonContent fullscreen>
                <IonItem>
                    <IonLabel>Email</IonLabel>
                    <IonInput value={obj.email} onIonChange={handleChange('email')}></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel>Password</IonLabel>
                    <IonInput value={obj.pwd} onIonChange={handleChange('pwd')}></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel>Comfirm Password</IonLabel>
                    <IonInput
                        value={obj.confirmPwd}
                        onIonChange={handleChange('confirmPwd')}
                    ></IonInput>
                </IonItem>

                <Box my="20px" px="20px">
                    <IonButton color="primary" expand="block" onClick={handleRegister}>
                        Register
                    </IonButton>
                    <Link to="/login">
                        <Text textAlign="right" mt="10px">
                            if you have an accoount? Login
                        </Text>
                    </Link>
                </Box>

                {/* {customerCreate && !customerCreate.customer && customerCreate.userErrors && (
                    <Text color="red" mt="10px">
                        {customerCreate.userErrors[0].message}
                    </Text>
                )} */}
                <IonLoading isOpen={loading}></IonLoading>
                <IonToast
                    position="top"
                    isOpen={Boolean(error || mutationError)}
                    onDidDismiss={() => setError('')}
                    message={error || mutationError}
                    duration={1200}
                />
            </IonContent>
        </IonPage>
    )
}
